<template>
  <div class="popup__header">
    <span>{{ title }}</span>
    <svg
      v-if="showClose"
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="#fff"
      stroke="#fff"
      stroke-width="3.2"
      stroke-linecap="round"
      stroke-linejoin="round"
      @click="closePopup"
      class="cursor-pointer"
    >
      <line x1="18" y1="6" x2="6" y2="18"></line>
      <line x1="6" y1="6" x2="18" y2="18"></line>
    </svg>
  </div>
</template>

<script>
export default {
  name: "PopupHeader",
  props: {
    title: {
      type: String,
      required: true,
    },
    showClose: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    closePopup() {
      this.$emit("close");
    },
  },
};
</script>
